import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import ManagementCompanyDetailsForm from "./ManagementCompanyDetailForm";
import { useDeleteManagementCompanyByIdMutation, useGetManagementCompanyByIdQuery } from "../managementCompany";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import ModalButton from "../../../../components/common/form/ModalButton";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import IconButton from "../../../../components/common/form/IconButton";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const ManagementCompanyDetailPage = () => {

  let { companyId } = useParams();

  const managementCompanyData = useGetManagementCompanyByIdQuery(companyId);

  const [crumbs, setCrumbs] = useState<any[]>([])
  const [deleteApi, { isLoading }] = useDeleteManagementCompanyByIdMutation();
  const navigate = useNavigate();
  useEffect(() => {

    setCrumbs([
      { content: "Home", url: "/home" },
      { content: "Management Companies", url: "/management-companies" },
      { content: "Update Management Company", url: "" }
    ])

  }, []);

  document.title = "Managemt-Company Detail"
  const handleDelete = async () => {
    if (companyId) {
      await deleteApi(companyId).unwrap();
    }
    navigate(AppRoutes.ManagementCompany.path)
  };


  return (
    <>
      <div className="px-5 py-5" >
        <div className={"justify-between sm:block md:flex lg:flex"}>
          <Breadcrumb crumbs={crumbs} />
          <div className={"justify-between sm:block md:flex lg:flex"}>
            {hasPermission(["MGTCOM-D"]) &&
              <ModalButton
                triggerButton={
                  <IconButton
                    icon={<FaTrash />}
                    title={"Delete Management Company"}
                    hasBackground={true}
                    className="mr-2"
                  />
                }
                modal={
                  <ConfirmationModal
                    show={true}
                    setShow={() => {
                    }}
                    title={"Delete Management Company"}
                    bodyMessage={"Are you sure you want to delete this Management Company?"}
                    onSubmit={() => handleDelete()}
                    isLoading={isLoading}
                  />
                }
              />
            }
            {hasPermission(["AUDIT-V"]) &&
              <AuditableInfoButton obj={managementCompanyData?.data} />
            }
          </div>
        </div >
        <ManagementCompanyDetailsForm />
      </div>
    </>
  );
};

export default ManagementCompanyDetailPage;